"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ripemd160 = void 0;
var uint8array_utils_1 = require("@harmoniclabs/uint8array-utils");
var ripemd_160_1 = require("./noble/ripemd_160.js");
function ripemd160(input) {
    if (typeof input === "string") {
        if (input.startsWith("0x"))
            input = (0, uint8array_utils_1.fromHex)(input.toLowerCase().slice(2));
        else if (isHex(input))
            input = (0, uint8array_utils_1.fromHex)(input.toLowerCase());
        else
            input = (0, uint8array_utils_1.fromUtf8)(input);
    }
    if (!(input instanceof Uint8Array))
        throw new Error("ripemd160: input must be Uint8Array or string");
    return new ripemd_160_1.RIPEMD160().update(input).digest();
}
exports.ripemd160 = ripemd160;
function isHex(str) {
    return /^[0-9A-Fa-f]*$/.test(str);
}
